import { defaultObj } from './state'

export default {
  setContactInfo (state, contactData) {
    if (contactData.contactInfo) {
      state.contactInfo = contactData.contactInfo
    }
  },

  reset (state) {
    state = Object.assign(state, defaultObj)

    if (this.cache.has('config/getContactInfo') === true) {
      this.cache.delete('config/getContactInfo')
    }
  }
}
